const EMPTY_AGENT_ID = "00000000-0000-0000-0000-000000000000";

const hasAgentId = (id?: string | null) =>
  typeof id === "string" && id.length > 0 && id !== EMPTY_AGENT_ID;

export const applyClientAgentToDocument = (
  document: any,
  clientAgentId?: string | null,
) => {
  if (!document || hasAgentId(document.agentId)) {
    return document;
  }

  const agentId =
    clientAgentId ||
    document?.client?.agentId ||
    document?.client?.AgentId;

  if (hasAgentId(agentId)) {
    document.agentId = agentId;
  }

  return document;
};
